import { PersonalManager } from '@my-account/const';
import { StateUtils } from '@spartacus/core';
import { PERSONAL_MANAGER_CONFIRMATION } from '../my-account-state';

export const GET_PERSONAL_MANAGER_CONFIRMATION = '[My Account] Get personal manager confirmation';
export const GET_PERSONAL_MANAGER_CONFIRMATION_SUCCESS = '[My Account] Get personal manager confirmation Success';
export const GET_PERSONAL_MANAGER_CONFIRMATION_FAIL = '[My Account] Get personal manager confirmation Fail';
export const GET_PERSONAL_MANAGER_CONFIRMATION_RESET = '[My Account] Get personal manager confirmation Reset';

export class GetPersonalManagerConfirmation extends StateUtils.LoaderLoadAction {
  readonly type = GET_PERSONAL_MANAGER_CONFIRMATION;

  constructor(public payload: string) {
    super(PERSONAL_MANAGER_CONFIRMATION);
  }
}

export class GetPersonalManagerConfirmationSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = GET_PERSONAL_MANAGER_CONFIRMATION_SUCCESS;

  constructor(public payload: PersonalManager) {
    super(PERSONAL_MANAGER_CONFIRMATION);
  }
}

export class GetPersonalManagerConfirmationFail extends StateUtils.LoaderFailAction {
  readonly type = GET_PERSONAL_MANAGER_CONFIRMATION_FAIL;

  constructor(public payload: unknown) {
    super(PERSONAL_MANAGER_CONFIRMATION);
  }
}

export class GetPersonalManagerConfirmationReset extends StateUtils.LoaderResetAction {
  readonly type = GET_PERSONAL_MANAGER_CONFIRMATION_RESET;

  constructor() {
    super(PERSONAL_MANAGER_CONFIRMATION);
  }
}

export type GetInfoManagerActions =
  | GetPersonalManagerConfirmation
  | GetPersonalManagerConfirmationSuccess
  | GetPersonalManagerConfirmationFail
  | GetPersonalManagerConfirmationReset;
